import React from 'react';
import type { SanityBlock } from '@sanity/client';
import { TextVariant } from '@naf/text';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import BlockImage from '../BlockImage/BlockImage';
import BlockContent from '../../../BlockContent';
import * as S from './NumberedListSerializer.styles';

interface Props {
  value: { numberedList?: { image: CloudinaryImageType; body: SanityBlock[]; title: string }[]; title: string };
}

export const NumberedList = ({ value: { numberedList } }: Props) => (
  <S.Wrapper className="numberedList">
    {numberedList?.map(({ image, body, title }, index) => (
      <S.ListItem key={title}>
        <S.StyledNumber size="small" value={index + 1} />
        <S.HeaderText variant={TextVariant.ArticleTextLargeHeader}>{title}</S.HeaderText>
        <S.ContentWrapper>
          <BlockImage image={image} />
          <BlockContent value={body} />
        </S.ContentWrapper>
      </S.ListItem>
    ))}
  </S.Wrapper>
);
